// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3iYuT","importantInfo":"styles_importantInfo__2QtSp"};